import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import { langCheck } from "Pub/js/utils";
import { setStore, getStore } from "Pub/js/storageUtils";
import moment from "moment";
export function sprLog(type, userId, callback) {
    if (type) {
        // 开启渲染时间和渲染次数记录
        // window.sys_monitor.startMonitor();

        this.modifySPR.data = { spr: true };
        window.dispatchEvent(this.modifySPR);
        Ajax({
            url: "/nccloud/platform/spr/start.do",
            info: {
                name: "spr",
                appcode: "10228888",
                action: langCheck('0000PUB-000128'), /* 国际化处理： 开启*/
            },
            sysAppcode: "10228888",
            data: {
                oprtime: moment().format("YYYY-MM-DD HH:mm:SS"),
                userid: userId,
            },
            success: res => {
                let { data } = res.data;
                if (data) {
                    setStore("sprTime", data);
                    // callback(!type);
                } else {
                    Notice({ status: "error", msg: res.error.message });
                }
            },
        });
        // callback(!type);
    } else {
        let autoBusiaction = localStorage.getItem("autoBusiaction"); // 自动化测试新增参数
        let win = null;
        if (!autoBusiaction) {
            win = window.open("", "_blank");
        }
        this.modifySPR.data = { spr: false };
        window.dispatchEvent(this.modifySPR);
        let { renderTimes, renderCost, renders } = MonitorData();
        let resTime = getStore("sprTime");
        console.log("sprcost---", renderTimes, renderCost, renders);
        const _this = this;
        Ajax({
            url: "/nccloud/platform/spr/end.do",
            info: {
                name: "spr",
                appcode: "10228888",
                action: langCheck('0000PUB-000129'), /* 国际化处理： 结束*/
            },
            sysAppcode: "10228888",
            data: {
                renderTimes,
                renderCost,
                renders,
                oprtime: resTime,
                userid: userId,
                autoBusiaction,
            },
            success: res => {
                // _this.modifySPR = null;
                let { data } = res.data;
                if (data) {
                    if (win) {
                        // callback(!type);
                        setStore("sprTime", !type);
                        if (win && win.location.href == "about:blank") {
                            if (!autoBusiaction) {
                                // 自动化测试 新增参数 没有的话还是原来逻辑
                                win.location.href = data;
                                win.focus();
                            } else {
                                // 有的话 直接给提示
                                win.close();
                                Notice({ status: "success", msg: langCheck('0000PUB-000601') }); // 录制spr成功
                            }
                        }
                    }
                } else {
                    if (win) {
                        win.close();
                    }
                    Notice({ status: "error", msg: res.error.message });
                }
            },
            error: () => {
                if (win) {
                    // callback(!type);
                    setStore("sprTime", !type);
                    win.close();
                }
            },
        });
    }
}
/**
 * 监控数据整理
 */
const MonitorData = () => {

    //let monitorData = window.sys_monitor.endMonitor();
    sessionStorage.setItem('sys_flag_bmonitor', false);
    let monitorData = window.monitorDataTotal ? JSON.stringify(window.monitorDataTotal) : JSON.stringify({ count: 0, countNumber: [], pageComponent: [] });
    if (monitorData.WARINING) {
        return {
            renderCost: 0,
            renderTimes: 0,
        };
    } else {
        monitorData = JSON.parse(monitorData);
        let renderCost = 0, renders = [];
        if (monitorData.countNumber.length > 0) {
            monitorData.countNumber.map(item => {
                let itemNum = item.split("：")[1].split("秒")[0];/* 国际化处理： 秒*/
                renderCost += itemNum - 0;
            });
        }
        if (monitorData.pageComponent && monitorData.pageComponent.length) {
            renders = gerComList(monitorData.pageComponent);
        }
        return {
            renderTimes: monitorData.count,
            renderCost,
            renders,
        };
    }

    window.monitorDataTotal = {};
};

const gerComList = pageComponent => {
    let pList = [], comMap = {}, cost;
    pageComponent.map(item => {
        comMap[item.componentName] = !comMap[item.componentName] ? [] : comMap[item.componentName];
        comMap[item.componentName].push(item);
    });
    for (let key in comMap) {
        let num = 0;
        name = key;
        let comList = comMap[key],
            id = comList[0].id;
        if (comList.some(item => { return item.id !== id; })) {
            let childIdCom = {};
            comList.map(list => {
                childIdCom[list.id] = !childIdCom[list.id] ? [] : childIdCom[list.id];
                childIdCom[list.id].push(list);
            });
            pList = pList.concat(forUtil(childIdCom));
        } else {
            for (let index = 0; index < comList.length; index++) {
                id = comList[index].id;
                if (index % 2 == 1) {cost = comList[index].renderDone - comList[index - 1].renderBegin;}
                if (index % 2 == 1) {num += 1;}
            }
            num && cost && pList.push({ name, id, time: cost / 1000, num });
        }
    }
    function forUtil(comMap) {
        let list = [];
        for (let key in comMap) {
            let num = 0,
                comList = comMap[key],
                id = comList[0].id,
                name = comList[0].componentName;
            for (let index = 0; index < comList.length; index++) {
                if (index % 2 == 1) {cost = comList[index].renderDone - comList[index - 1].renderBegin;}
                if (index % 2 == 1) {num += 1;}
            }
            num && cost && list.push({ name, id, time: cost / 1000, num });
        }

        return list;
    }
    return pList.sort(function (a, b) {
        return a.num - b.num;
    });
};
